var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcAcPcsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92.2,
    height: 92.2,
    viewBox: "0 0 92.2 92.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7,6L6,89.7c2.3,1.6,5,2.5,8,2.5h64.2c7.7,0,14-6.3,14-14V14C92.2,11,91.2,8.3,89.7,6z M73.5,80.1     c-5.8,0-10.6-4.7-10.6-10.6c0-3.1-2.5-5.6-5.6-5.6c-3.1,0-5.6,2.5-5.6,5.6c0,3.7-5,3.1-5,0c0-5.8,4.7-10.6,10.6-10.6     c5.8,0,10.6,4.7,10.6,10.6c0,3.1,2.5,5.6,5.6,5.6c3.1,0,5.6-2.5,5.6-5.6c0-3.7,5-3.9,5,0C84,75.3,79.3,80.1,73.5,80.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.2,0H14C6.3,0,0,6.3,0,14v64.2c0,3.1,1,6,2.7,8.3L86.5,2.7C84.1,1,81.3,0,78.2,0z M23.8,30.3h-13             c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h13c1.7,0,3.1,1.4,3.1,3.1C26.9,28.9,25.5,30.3,23.8,30.3z M51,30.3H38             c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1h13c1.7,0,3.1,1.4,3.1,3.1C54.1,28.9,52.7,30.3,51,30.3z M51,18H10.8             c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1H51c1.7,0,3.1,1.4,3.1,3.1S52.7,18,51,18z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcAcPcsIcon);
export default __webpack_public_path__ + "static/media/dc-ac-pcs-icon.933cca5e260d78f7b8fba6f28325c92f.svg";
export { ForwardRef as ReactComponent };